import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { contractingActivityKeys } from "@/lib/query-keys";
import type { TimelineEntry } from "@/types/domain";

/** Historial de una licitación: cambios de estado, traspasos, notas y aperturas. */
export function useContractingTimeline(contractingId?: number, enabled = true) {
  return useQuery({
    queryKey: contractingActivityKeys.timeline(contractingId),
    enabled: enabled && !!contractingId,
    queryFn: () =>
      fetchToBackend<TimelineEntry[]>(`/contractingactivity/${contractingId}`),
  });
}
